import { Box, Loader, ModBox, Spacer, Text, TextNew } from '@jfs/ui-new'
import { ButtonNew } from '../../../../components/AdminButton'
import { useEffect, useRef, useState } from 'react'
import { EmType } from '../..'
import { useLazyApiData, useStores } from '../../../../data/store'
import { isAccessible } from '../../../../utils'
import { ContactItem } from './ContactItem'

interface ContactProfilesProps {
  type: string
  isEditMode: boolean
  onDataChange: (index: number, key: string, value: string) => void
  isValidToProceed: (isValid: boolean) => void
  selectedEntity?: any
  isLinkToMAS?: boolean
  isEditable?: boolean
}

const getGroupAllowNotification = (data: any) => {
  return data?.sms === true && data?.email === true
    ? 'All'
    : data?.sms === true && data?.email === false
    ? 'SMS'
    : data?.sms === false && data?.email === true
    ? 'EMAIL'
    : ''
}

const ContactProfiles = ({
  type,
  isEditMode = false,
  onDataChange,
  isValidToProceed,
  selectedEntity,
  isLinkToMAS = false,
  isEditable,
}: ContactProfilesProps) => {
  const {
    getContactProfiles,
    fetchAllLovs,
    searchedMasMid,
    updateEntity,
    isEntityPresentInMas,
    pushItemContactProfiles,
    deleteContactProfiles,
    getContactProfilesFromTaskId,
    getContactProfileFromGroup,
    searchFilterBy,
    updateGroupSubGroup,
    getUpdatedGroupSubGroupContactProfile,
    saveEnteredContactProfile,
    saveState,
    resetState,
    isSyncDone,
    accessConfig,
    getUpdatedEntityContactProfile,
  } = useStores((store) => ({
    getContactProfiles: store.getEntityContactProfiles,
    fetchAllLovs: store.fetchAllLovs,
    searchedMasMid: store.onboarding.searchedMasMid,
    updateEntity: store.updateEntity,
    isEntityPresentInMas: store.onboarding.isEntityPresentInMas,
    pushItemContactProfiles: store.onboarding.pushItemContactProfiles,
    deleteContactProfiles: store.onboarding.deleteContactProfiles,
    getContactProfilesFromTaskId: store.getContactProfilesFromTaskId,
    getContactProfileFromGroup: store.getContactProfileFromGroup,
    searchFilterBy: store.onboarding.searchFilterBy,
    updateGroupSubGroup: store.updateGroupSubGroup,
    getUpdatedGroupSubGroupContactProfile: store.getGroupSubGroupContactProfile,
    saveEnteredContactProfile: store.onboarding.saveEnteredContactProfile,
    saveState: store.onboarding.saveState,
    resetState: store.onboarding.resetState,
    isSyncDone: store.onboarding.isSyncDone,
    accessConfig: store.user.getAccessConfig(['entity_management_service', 'ems_config']),
    getUpdatedEntityContactProfile: store.getUpdatedEntityContactProfile,
  }))

  const keysArray = [
    'Gender',
    'MDRPackageId',
    'SettlementFreq',
    'SettlementStatus',
    'IndustryType',
    'FilterType',
    'PaymentSettings',
    'OnboardingChannel',
    'UserType',
    'mcc',
    'Role',
    'State',
    '',
    '',
    '',
  ]
  const [getAllLovs, getLovHandler] = useLazyApiData(fetchAllLovs)
  const [updateEntityApi, updateEntityHandler] = useLazyApiData(updateEntity)
  const [updateGroupSubGroupApi, updateGroupSubGroupHandler] = useLazyApiData(updateGroupSubGroup)

  const [dataArr, setDataArr] = useState([])
  const isValidArray = useRef([] as boolean[])
  const [count, setCount] = useState(1)
  const [isEdit, setEditMode] = useState(isEditMode)
  const [isAddBtnEnabled, setAddBtnEnabled] = useState(false)
  const [dummyValue, setDummyValue] = useState('initDummy')

  useEffect(() => {
    if (selectedEntity === undefined && searchedMasMid === '') {
      if (saveEnteredContactProfile) {
        setDataArr(getContactProfiles(selectedEntity, type))
      } else {
        setDataArr(['1'])
      }
    } else if (selectedEntity && selectedEntity.id) {
      setDataArr(getContactProfiles(selectedEntity.id ?? selectedEntity.masMid, type))
    } else if (searchedMasMid.length > 0) {
      setDataArr(getContactProfiles(searchedMasMid, type))
    } else if (
      selectedEntity &&
      selectedEntity.identificationNumber &&
      (searchFilterBy === 'Group ID' || searchFilterBy === 'SubGroup ID')
    ) {
      setDataArr(getContactProfileFromGroup(selectedEntity.identificationNumber))
    } else if (type === EmType.applicationQueue && selectedEntity && selectedEntity?.applicationId?.length > 0) {
      setDataArr(getContactProfilesFromTaskId(selectedEntity?.applicationId))
    }
  }, [
    getContactProfileFromGroup,
    getContactProfiles,
    getContactProfilesFromTaskId,
    saveEnteredContactProfile,
    searchFilterBy,
    searchedMasMid,
    selectedEntity,
    type,
  ])

  useEffect(() => {
    console.log('getAllLovs keys: ', ...keysArray)
    getAllLovs(...keysArray)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (
      updateEntityHandler.state === 'fulfilled' ||
      updateEntityHandler.state === 'rejected' ||
      updateGroupSubGroupHandler.state === 'rejected' ||
      updateGroupSubGroupHandler.state === 'fulfilled'
    ) {
      if (
        selectedEntity &&
        selectedEntity.identificationNumber &&
        updateGroupSubGroupHandler.state === 'fulfilled' &&
        (searchFilterBy === 'Group ID' || searchFilterBy === 'SubGroup ID')
      ) {
        setDataArr(getContactProfileFromGroup(selectedEntity.identificationNumber))
      } else if (updateGroupSubGroupHandler.state === 'rejected') {
        resetState()
      }
      setEditMode(false)
    }
  }, [
    getContactProfileFromGroup,
    resetState,
    searchFilterBy,
    selectedEntity,
    updateEntityHandler.state,
    updateGroupSubGroupHandler.state,
  ])

  const onAddPress = () => {
    isValidToProceed(false)
    setCount((prevCount) => prevCount + 1)
    const mDataArr = [`${count}`, ...dataArr]
    setDataArr(mDataArr)
    pushItemContactProfiles(`${count}`)
  }

  const onDeletePress = (index: number) => {
    setCount((prevCount) => prevCount - 1)
    if (dataArr.length > 0) {
      dataArr.pop()
      setDataArr(dataArr)
      deleteContactProfiles(index)
    }
  }

  const onEditPress = () => {
    setEditMode(true)
    saveState()
    setDummyValue('initDummy')
  }
  const onEditCancelPress = () => {
    resetState()
    setEditMode(false)
    setDummyValue('cancelDummy')
  }
  const onSavePress = () => {
    if (selectedEntity && selectedEntity.id) {
      updateEntityApi(selectedEntity?.id, 'contactDetails', getUpdatedEntityContactProfile(selectedEntity.id, type))
    } else if (searchedMasMid.length > 0) {
      updateEntityApi(selectedEntity?.id, 'contactDetails', getUpdatedEntityContactProfile(searchedMasMid, type))
    } else if (
      selectedEntity.identificationNumber &&
      (searchFilterBy === 'Group ID' || searchFilterBy === 'SubGroup ID')
    ) {
      updateGroupSubGroupApi({
        identificationNumber: selectedEntity?.identificationNumber,
        type: searchFilterBy === 'Group ID' ? 'GROUP' : 'SUBGROUP',
        groupContacts: [...getUpdatedGroupSubGroupContactProfile(selectedEntity.identificationNumber)],
      })
    }
  }
  console.log('ContactProfiles type', type, selectedEntity, isEditMode, isEdit)

  const checkIfAllContactItemsAreValid = (index: number, isValid: boolean) => {
    isValidArray.current[index] = isValid
    const isAllValid = isValidArray.current.reduce((prev, curr) => prev && curr, true)
    setAddBtnEnabled(isAllValid || isValid)
    isValidToProceed && isValidToProceed(isAllValid || isValid)
  }

  return (
    <>
      <ModBox f={1} show={getLovHandler?.state === 'pending'} alignItems={'center'} justifyContent={'center'}>
        <Loader type={'large'} color="PRIMARY" />
      </ModBox>
      <ModBox
        show={getLovHandler?.state !== 'pending'}
        f={1}
        nativeID="vertical-scroll"
        overflow={'auto'}
        ph={40}
        pv={40}
        pointerEvents={isEditable ? 'auto' : 'none'}
        backgroundColor={'WHITE'}
        h={'90%'}>
        <Box direction="row" justifyContent={'space-between'}>
          <Text title={'Contact Profiles'} color={'BLACK_21'} fontSize={18} fontFamily={'jiotype-bold'} />
          <ModBox
            show={
              (!isEdit &&
                type === EmType.Search &&
                !isEntityPresentInMas(selectedEntity?.id) &&
                dataArr?.length !== 0) ||
              type === EmType.createSingleEntity ||
              type === EmType.createGroup
            }
            justifyContent="flex-end">
            <ModBox direction={'row'} alignItems={'center'}>
              <ModBox show={type !== EmType.Search && !isLinkToMAS}>
                <ButtonNew
                  type={'secondaryIconSmall'}
                  borderWidth={1}
                  title={'Add Contact Profiles'}
                  borderColor={'#0070B6'}
                  borderRadius={4}
                  disabled={!isAddBtnEnabled}
                  icon="ADD"
                  onPress={onAddPress}
                />
              </ModBox>
              <Spacer size={16} direction={'horizontal'} />
              <ModBox
                show={
                  type !== EmType.createSingleEntity &&
                  type !== EmType.createGroup &&
                  isAccessible(accessConfig, 'create')
                }>
                <ButtonNew
                  type={'secondaryIconSmall'}
                  borderWidth={1}
                  title={'Edit'}
                  borderColor={'#0070B6'}
                  borderRadius={4}
                  icon="EDIT"
                  onPress={onEditPress}
                />
              </ModBox>
            </ModBox>
          </ModBox>
        </Box>
        <ModBox show={type === EmType.Search && !isEntityPresentInMas(selectedEntity?.id)}>
          <ModBox show={isEdit} direction={'row'} justifyContent="flex-end">
            <ButtonNew
              type={'secondarySmall'}
              borderWidth={1}
              title={'Cancel'}
              borderColor={'#0070B6'}
              borderRadius={4}
              onPress={onEditCancelPress}
            />
            <Spacer size={16} direction={'horizontal'} />
            <ButtonNew
              color={'#0070B6'}
              height={32}
              borderWidth={1}
              title={'Save Changes'}
              borderColor={'#0070B6'}
              borderRadius={4}
              isLoading={updateEntityHandler?.state === 'pending' || updateGroupSubGroupHandler?.state === 'pending'}
              disabled={!isAddBtnEnabled}
              onPress={onSavePress}
            />
          </ModBox>
        </ModBox>
        <ModBox overflow={'auto'} direction={type === EmType.Search ? 'column' : 'column-reverse'} marginTop={32}>
          {dataArr?.length > 0 &&
            dataArr?.map((data: any, index: number) => {
              return (
                <ContactItem
                  key={index}
                  data={data}
                  index={index}
                  isEditMode={isEdit}
                  onDeletePress={onDeletePress}
                  onDataChange={onDataChange}
                  isValidToProceed={checkIfAllContactItemsAreValid}
                  emsType={type}
                  allowNotification={
                    data?.allowNotification?.length > 0
                      ? data?.allowNotification
                      : getGroupAllowNotification(data?.groupContactNotification)
                  }
                  dummyValue={dummyValue}
                  dataLength={dataArr?.length}
                />
              )
            })}
        </ModBox>
        <ModBox show={dataArr?.length === 0} marginTop={32}>
          <TextNew title="No data found" color={'PRIMARY'} fontSize={16} fontWeight="BOLD" />
        </ModBox>
      </ModBox>
    </>
  )
}

export { ContactProfiles }
